module.exports = __webpack_public_path__ + "static/media/sparkles-logo.9f24b148.png";